<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="editCotacao && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitCotacao" v-if="!editCotacao || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editCotacao || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Recurso" prop="recurso_id" :rules="[$requiredChange]" key="recurso_id">
              <el-select v-model="dados.recurso_id" placeholder="pesquisar..." filterable remote :remote-method="getRecursoByFilter" :loading="loadingRecurso">
                <el-option v-for="item in recursos" :key="item.id" :label="recursoLabel(item)" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
              <el-select v-model="dados.status">
                <el-option label="ABERTA" value="aberta"></el-option>
                <el-option label="AGUARDANDO PROPOSTAS" value="aguardando_propostas"></el-option>
                <el-option label="FINALIZADA" value="finalizada"></el-option>
                <el-option label="CANCELADA" value="cancelada"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Nº processo" prop="numero_processo" key="numero_processo">
              <el-input v-model="dados.numero_processo" maxlength="191" v-on:blur="formatData('numero_processo')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Valor estimado" prop="valor_estimado" key="valor_estimado">
              <el-input v-model="dados.valor_estimado" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data início" prop="data_inicio" key="data_inicio">
              <el-date-picker v-model="dados.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data fim" prop="data_fim" key="data_fim">
              <el-date-picker v-model="dados.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-cotacao" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editCotacao: false,
    loadingRecurso: false,
    recursos: [],
    filtroInstituicao: { id: '', nome: '' },
    dados: {
      id: '',
      instituicao_id: '',
      recurso_id: '',
      numero_processo: '',
      descricao: '',
      status: 'aberta',
      valor_estimado: '',
      data_inicio: '',
      data_fim: ''
    }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    getCotacaoById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/cotacao/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => {
          const data = JSON.parse(JSON.stringify(response.data))

          // Pré-popular options do select remoto (senão ele mostra o ID)
          if (data && data.recurso) {
            this.recursos = [data.recurso]
            delete data.recurso
          }

          this.dados = data
        })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    getRecursoByFilter (query) {
      if (!query || query.length < 2) {
        this.recursos = []
        return false
      }
      this.loadingRecurso = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/recurso/searchByNome`, { query }, this.$store.getters.getHeaderAuth).then(response => {
        this.recursos = JSON.parse(JSON.stringify(response.data))
        this.loadingRecurso = false
      }).catch((error) => { this.loadingRecurso = false; this.$store.commit('throwException', error) })
    },
    recursoLabel (item) {
      const programa = item.programa ? item.programa.nome : ('#' + item.programa_id)
      const ano = item.ano ? item.ano : ''
      const valor = (item.valor_total != null) ? this.formatMoney(item.valor_total) : ''
      return `${programa} - ${ano} - ${valor}`
    },
    onSubmitCotacao () {
      document.getElementById("btn-cotacao").focus()

      this.$refs.dados.validate((valid) => {
        if (valid) {
          const inst = this.$store.state.config.instituicao
          if (!inst || !inst.id) {
            return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
          }
          window.eventBus.$emit('loading', true)
          this.dados.instituicao_id = inst.id

          if (this.editCotacao) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/cotacao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitCotacao')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/cotacao/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitCotacao')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatData (field) {
      if (!this.dados[field]) return false
      this.dados[field] = this.dados[field].toUpperCase()
      this.dados[field] = this.$removerAcentos(this.dados[field])
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getCotacaoById(value)
          this.editCotacao = true
        }
      }
    }
  }
}
</script>

